import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlertSuccessComponent } from "./med-icon-alert-success.component";

@NgModule({
  declarations: [
    MedIconAlertSuccessComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlertSuccessComponent,
  ],
})
export class MedIconAlertSuccessModule { }
